import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from "react-router-dom";

import { Spinner } from './components/Utils/Loaders';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { AuthorizeRoute } from "./components/api-authorization/AuthorizeRoute";
import AdminLayout from './layouts/Admin';
import { settingsActions } from './store/Configuration';

export default () => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const currentUser = useSelector(state => state.authentication.user);
    const settingsState = useSelector(state => state.settings);
    const { i18n } = useTranslation()

    useEffect(() => {
        if (isAuthenticated) {
            i18n.changeLanguage(currentUser.language);
            dispatch(settingsActions.requestDigitalSignEnabled());
        }
    }, [isAuthenticated]);

    if (settingsState.isLoading)
        return <Spinner />;

    return (
        <Switch>
            <AuthorizeRoute path="/admin" component={props => <AdminLayout {...props} />} />
            <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
            <Redirect from="/" to="/admin/dashboard" />
        </Switch>
    );
}